<div class="overlay" *ngIf="isLoading | async as message">
  <div class="mat-progress-spinner text-center">
    <p> {{message}}</p>
    <div class="spinner-border text-warning" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>